/**
 * Section Component
 * Generic section wrapper for editor panels
 */

import React from 'react';

interface SectionProps {
  /** Section title */
  title: string;

  /** Optional description */
  description?: string;

  /** Section content */
  children: React.ReactNode;

  /** Optional CSS class */
  className?: string;
}

/**
 * Section Component
 * Provides consistent styling for editor sections
 */
export function Section({ title, description, children, className = '' }: SectionProps) {
  return (
    <div className={`space-y-4 ${className}`}>
      <div className="space-y-1">
        <h3 className="text-sm font-semibold">{title}</h3>
        {description && <p className="text-xs text-muted-foreground">{description}</p>}
      </div>
      <div className="space-y-4">{children}</div>
    </div>
  );
}
